module.exports = __webpack_public_path__ + "img/other_1plus2.ce7904bf.jpg";